import { Category } from "fileParsing/types";
import Tooltip, { type TooltipTexts } from "containers/Components/Tooltip";
import { useMemo } from "react";
import type { Link } from "./Sankey";

type ToolTipSettings = {
  tooltipWidth: number;
  margin: number;
};

type Props = {
  visible: boolean;
  settings: ToolTipSettings;
  position: { x: number; y: number };
  link?: Link;
  linkSourceName?: string;
  linkTargetName?: string;
};

function TargetNameFormatter(targetNodeName: string) {
  const targets = targetNodeName.split(/,\s*(?=[A-Z])/);
  const formattedName = targets.map((target) => `- ${target.trim()}\n`).join("");
  return formattedName;
}

function TooltipWrapper({ visible, settings, position, link, linkSourceName, linkTargetName }: Props) {
  const texts = useMemo<TooltipTexts>(() => {
    if (link) {
      return {
        title: link.catAsSource ? `${linkSourceName}` : `${linkTargetName}`,
        subtitle: link.sensitivity ? `This data is ${link.sensitivity}.` : "",
        body: link.catAsSource
          ? `${link.count} data points from ${linkSourceName} are associated with: \n${TargetNameFormatter(
              linkTargetName,
            )}`
          : `${link.count} data points from ${linkTargetName} are associated with: \n${TargetNameFormatter(
              linkSourceName,
            )}`,
      };
    } else {
      return {
        title: "",
        subtitle: "",
        body: "",
      };
    }
  }, [link, linkSourceName, linkTargetName]);

  return <Tooltip visible={visible} position={position} settings={settings} texts={texts} category={Category.Other} />;
}

export default TooltipWrapper;
